import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=6324675e&"
import script from "./MenuComponent.vue?vue&type=script&lang=ts&"
export * from "./MenuComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6324675e')) {
      api.createRecord('6324675e', component.options)
    } else {
      api.reload('6324675e', component.options)
    }
    module.hot.accept("./MenuComponent.vue?vue&type=template&id=6324675e&", function () {
      api.rerender('6324675e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuComponent.vue"
export default component.exports